module.exports = {
      id: "icon-chevron-small-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-chevron-small-left",
      toString: function () {
        return this.url;
      }
    }